import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tabs,
  Tab,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
} from '@mui/material';
import { TableRestaurant as TableIcon } from '@mui/icons-material';
import type { PisoResponse } from '../types/pos.types';
import { ESTADOS_MESA } from '../types/pos.types';

interface TransferTableDialogProps {
  open: boolean;
  onClose: () => void;
  onTransfer: (idMesaDestino: number) => void;
  pisos: PisoResponse[];
  mesaActualId: number;
}

export const TransferTableDialog: React.FC<TransferTableDialogProps> = ({
  open,
  onClose,
  onTransfer,
  pisos,
  mesaActualId,
}) => {
  const [pisoTab, setPisoTab] = useState(0);
  const [selectedMesa, setSelectedMesa] = useState<number | null>(null);

  const handleClose = () => {
    setSelectedMesa(null);
    onClose();
  };

  const handleTransfer = () => {
    if (selectedMesa) {
      onTransfer(selectedMesa);
      setSelectedMesa(null);
    }
  };

  const currentPiso = pisos[pisoTab];
  const mesasDisponibles = currentPiso?.mesas.filter(
    (m) => m.idMesa !== mesaActualId && m.estado === ESTADOS_MESA.DISPONIBLE
  ) ?? [];

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Transferir a otra mesa</DialogTitle>
      <DialogContent>
        {pisos.length > 1 && (
          <Tabs
            value={pisoTab}
            onChange={(_e, val) => setPisoTab(val)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}
          >
            {pisos.map((piso, idx) => (
              <Tab key={piso.idPiso} label={piso.nombre} value={idx} />
            ))}
          </Tabs>
        )}

        {mesasDisponibles.length > 0 ? (
          <Grid container spacing={1}>
            {mesasDisponibles.map((mesa) => (
              <Grid key={mesa.idMesa} size={{ xs: 4, sm: 3 }}>
                <Card
                  variant="outlined"
                  sx={{
                    borderColor: selectedMesa === mesa.idMesa ? 'primary.main' : 'divider',
                    borderWidth: selectedMesa === mesa.idMesa ? 2 : 1,
                    bgcolor: selectedMesa === mesa.idMesa ? 'primary.50' : undefined,
                  }}
                >
                  <CardActionArea onClick={() => setSelectedMesa(mesa.idMesa)}>
                    <CardContent sx={{ p: 1, textAlign: 'center', '&:last-child': { pb: 1 } }}>
                      <TableIcon sx={{ color: '#4caf50', fontSize: 24 }} />
                      <Typography variant="body2" fontWeight="bold">
                        Mesa {mesa.numero}
                      </Typography>
                      {mesa.nombre && (
                        <Typography variant="caption" color="text.secondary">
                          {mesa.nombre}
                        </Typography>
                      )}
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <Typography color="text.secondary">
              No hay mesas disponibles en este piso
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleTransfer}
          disabled={!selectedMesa}
        >
          Transferir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferTableDialog;
